import { useState } from "react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";
import { CaretUpDown, Check } from "@phosphor-icons/react";

// Searchable single-country picker; `selected` and `onSelect` use the country name
export default function CountryCombobox({
  countries,
  loading,
  selected,
  onSelect,
  placeholder = "Search and select country...",
  className,
}) {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type='button'
          className={cn(
            "flex items-center justify-between w-full px-3 py-2 text-sm transition-colors border rounded-md border-white/10 bg-white/5 text-white/60 hover:bg-white/10",
            className
          )}
        >
          <span className={selected ? "text-white" : ""}>
            {selected || placeholder}
          </span>
          <CaretUpDown className='flex-shrink-0 ml-2 text-white/40' />
        </button>
      </PopoverTrigger>
      <PopoverContent
        className='w-[--radix-popover-trigger-width] p-0'
        align='start'
      >
        <Command>
          <CommandInput placeholder='Search country...' />
          <CommandList>
            {loading ? (
              <CommandEmpty>Loading...</CommandEmpty>
            ) : (
              <>
                <CommandEmpty>No country found.</CommandEmpty>
                <CommandGroup>
                  {countries.map((c) => (
                    <CommandItem
                      key={c.id}
                      value={c.country_name}
                      onSelect={() => {
                        onSelect(c.country_name);
                        setOpen(false);
                      }}
                    >
                      <span className='flex-1'>{c.country_name}</span>
                      {selected === c.country_name && (
                        <Check className='text-sm text-primary' />
                      )}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </>
            )}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
